export const RP_SHIFT_MODEL_LIST = 'RP_SHIFT_MODEL_LIST'
export const RP_SHIFT_SEARCH = 'RP_SHIFT_SEARCH'
export const RP_SHIFT_PAGINATION = 'RP_SHIFT_PAGINATION'